import { getAccountsLoginUrl } from '@/services/auth';

const NoProductAccess = () => {
  const accountsUrl = (() => {
    const loginUrl = getAccountsLoginUrl('/');
    if (!loginUrl) return '/auth';
    try {
      const url = new URL(loginUrl);
      const redirect = url.searchParams.get('redirect') || '/auth';
      return new URL(redirect).origin;
    } catch {
      return '/auth';
    }
  })();

  const plansHref = `${accountsUrl.replace(/\/$/, '')}/plans`;
  const illustrationUrl = `${accountsUrl.replace(/\/$/, '')}/no-access-illustration.gif`;

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md w-full text-center space-y-8">
        <a href={plansHref} target="_blank" rel="noopener noreferrer" className="inline-block focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 rounded-xl transition-transform hover:scale-105 active:scale-100" aria-label="Go to plans and pricing">
          <img src={illustrationUrl} alt="" className="w-72 h-60 mx-auto object-contain" onError={(e) => { const target = e.currentTarget; target.style.display = 'none'; if (target.nextElementSibling) (target.nextElementSibling as HTMLElement).style.display = 'block'; }} />
          <svg className="h-60 w-72 mx-auto text-amber-500 hidden" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
          </svg>
        </a>
        <div className="space-y-3">
          <h1 className="text-2xl font-bold text-gray-900">No access to Calendar</h1>
          <p className="text-gray-600 text-base leading-relaxed">Your organization does not have access to this app yet. Contact your organization admin or subscribe to a plan to get access.</p>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 justify-center pt-2">
          <a href={plansHref} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-5 py-2.5 rounded-lg bg-primary-600 text-white font-medium hover:bg-primary-700 transition-colors">
            View plans &amp; subscribe
          </a>
          <a href={accountsUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-5 py-2.5 rounded-lg border border-gray-300 text-gray-700 font-medium hover:bg-gray-50 transition-colors">
            Open Accounts
          </a>
        </div>
      </div>
    </div>
  );
};

export default NoProductAccess;
